module.exports = __webpack_public_path__ + "images/56a31532b3d6b12de78c5749587064a9.svg";